import {appName} from '../settings/constants'
import {createSelector} from 'reselect'
import {Record, Map} from 'immutable'
import {hideLoading, showLoading} from "react-redux-loading-bar"
import {LOADER_BAR_Q_LOADER_MODAL_SCOPE} from '../settings/constants'


/**
 * Constants
 * */

export const moduleName = 'modals'
const prefix = `${appName}/${moduleName}`

export const SHOW_MODAL = `${prefix}/SHOW_MODAL`
export const HIDE_MODAL = `${prefix}/HIDE_MODAL`

export const defaultZindex = 1111
export const CREATE_DIALOG = `${prefix}/CREATE_DIALOG`
export const QBM_CRUD = `${prefix}/QBM_CRUD`
export const QBM_SEND = `${prefix}/QBM_SEND`
export const QBM_QUIZ = `${prefix}/QBM_QUIZ`
export const QBM_CLEAR_STATISTIC_FORM = `${prefix}/QBM_CLEAR_STATISTIC_FORM`
export const MODAL_FORM_QBM = `${prefix}/MODAL_FORM_QBM`
export const MODAL_FORM_TEACHER = `${prefix}/MODAL_FORM_TEACHER`
export const MODAL_FORM_UPDATE_QUIZS = `${prefix}/MODAL_FORM_UPDATE_QUIZS`
export const QBM_PRESENTATION = `${prefix}/QBM_PRESENTATION`
export const QBM_SHARED_QUESTION = `${prefix}/QBM_SHARED_QUESTION`
export const MODAL_VIDE_INFO = `${prefix}/MODAL_VIDE_INFO`
export const QBM_USER_BOOKS = `${prefix}/QBM_USER_BOOKS`
export const MODAL_QUESTION_QUIZ_DELETE = `${prefix}/MODAL_QUESTION_QUIZ_DELETE`
export const MODAL_QUESTION_TRASHED_DELETE = `${prefix}/MODAL_QUESTION_TRASHED_DELETE`
export const MODAL_QUESTION_TRASHED_RECOVERY = `${prefix}/MODAL_QUESTION_TRASHED_RECOVERY`
export const MODAL_ROOM_FORM = `${prefix}/MODAL_ROOM_FORM`
export const MODAL_QUESTION_MULTY_CATEGORY_FORM = `${prefix}/MODAL_QUESTION_MULTY_CATEGORY_FORM`
export const MODAL_QUESTION_MULTY_CATEGORY_FRAME = `${prefix}/MODAL_QUESTION_MULTY_CATEGORY_FRAME`
export const MODAL_QUESTION_MULTY_CATEGORY_DELETE = `${prefix}/MODAL_QUESTION_MULTY_CATEGORY_DELETE`
export const MODAL_QUESTION_MULTY_SUBJECT_FORM = `${prefix}/MODAL_QUESTION_MULTY_SUBJECT_FORM`
export const MODAL_QUESTION_MULTY_FORM = `${prefix}/MODAL_QUESTION_MULTY_FORM`
export const MODAL_QUESTION_MULTY_FORM_TRASHED = `${prefix}/MODAL_QUESTION_MULTY_FORM_TRASHED`
export const MODAL_QUESTION_MULTY_SUBJECT_DELETE = `${prefix}/MODAL_QUESTION_MULTY_SUBJECT_DELETE`
export const MODAL_CARD_CATEGORY_FORM = `${prefix}/MODAL_CARD_CATEGORY_FORM`
export const MODAL_CARD_CATEGORY_FRAME = `${prefix}/MODAL_CARD_CATEGORY_FRAME`
export const MODAL_CARD_CATEGORY_DELETE = `${prefix}/MODAL_CARD_CATEGORY_DELETE`
export const MODAL_CARD_SUBJECT_FORM = `${prefix}/MODAL_CARD_SUBJECT_FORM`
export const MODAL_CARD_FORM = `${prefix}/MODAL_CARD_FORM`
export const MODAL_CARD_FORM_TRASHED = `${prefix}/MODAL_CARD_FORM_TRASHED`
export const MODAL_CARD_SUBJECT_DELETE = `${prefix}/MODAL_CARD_SUBJECT_DELETE`
export const MODAL_STUDENT_FORM = `${prefix}/MODAL_STUDENT_FORM`
export const MODAL_STUDENT_FORM_VIEW = `${prefix}/MODAL_STUDENT_FORM_VIEW`
export const MODAL_ADD_STUDENT_ROOM = `${prefix}/MODAL_ADD_STUDENT_ROOM`
export const MODAL_USERS_ROOMS = `${prefix}/MODAL_USERS_ROOMS`
export const MODAL_ROOM_DELETE = `${prefix}/MODAL_ROOM_DELETE`
export const MODAL_QUIZ_DELETE = `${prefix}/MODAL_QUIZ_DELETE`
export const MODAL_FOLDER_FORM = `${prefix}/MODAL_FOLDER_FORM`
export const MODAL_PRESENT_ITEM_DELETE = `${prefix}/MODAL_PRESENT_ITEM_DELETE`
export const MODAL_FOLDER_DELETE = `${prefix}/MODAL_FOLDER_DELETE`
export const MODAL_PRESENTATION_FORM = `${prefix}/MODAL_PRESENTATION_FORM`
export const MODAL_PRESENTATION_COPY = `${prefix}/MODAL_PRESENTATION_COPY`
export const MODAL_PRESENTATION_DELETE = `${prefix}/MODAL_PRESENTATION_DELETE`
export const ADD_MEDIA = `${prefix}/ADD_MEDIA`
export const CONFIRM = `${prefix}/CONFIRM`
export const CONFIRM_TYPE_WARNING = `${prefix}/CONFIRM_TYPE_WARNING`
export const CONFIRM_TYPE_PRIMARY = `${prefix}/CONFIRM_TYPE_PRIMARY`
export const SELECT = `${prefix}/SELECT`
export const SELECT3 = `${prefix}/SELECT3`
export const RENDER_BODY = `${prefix}/RENDER_BODY`
export const TRASHED_QUESTION_MODAL = `${prefix}/TRASHED_QUESTION_MODAL`
export const TEMP_QUESTION_MODAL = `${prefix}/TEMP_QUESTION_MODAL`
export const INFO = `${prefix}/INFO`
export const INFO_TYPE_INFO = `${prefix}/INFO_TYPE_INFO`
export const INFO_TYPE_PRIMARY = `${prefix}/INFO_TYPE_PRIMARY`
export const INFO_TYPE_WARNING = `${prefix}/INFO_TYPE_WARNING`
export const INFO_TYPE_ERROR = `${prefix}/INFO_TYPE_ERROR`
export const POPOVER = `${prefix}/POPOVER`
export const Q_LOADER = `${prefix}/Q_LOADER`

export const IMPORT_EXPORT_QUESTIONS_MODAL = `${prefix}/IMPORT_EXPORT_QUESTIONS_MODAL`


/**
 * Reducer
 * */

const modalTypeRecord = Record({
    type : "",
    props : {},
    zIndex : defaultZindex,
})

const ReducerRecord = Record({
    entities : new Map({}),
})

const defaultState = new ReducerRecord()

export default (state = defaultState, action) => {
    let {type, payload} = action

    switch (type) {
        case SHOW_MODAL : {
            let {modalType, modalProps = {}, zIndex = defaultZindex} = payload
            return state.setIn(['entities', modalType], new modalTypeRecord({
                type : modalType,
                props : modalProps,
                zIndex,
            }))
            break
        }
        case HIDE_MODAL : {
            let {modalType} = payload
            return state.deleteIn(['entities', modalType])
            break
        }
        default : {
            return state
            break
        }
    }
}


/**
 * Selectors
 * */

export const stateSelector = state => state[moduleName]
export const modalsMapSelector = createSelector(stateSelector, state => state.entities)
export const modalsSelector = createSelector(modalsMapSelector, modals => modals.valueSeq().toArray())

/**
 * Action Creators
 * */

export const showModal = (params) => {
    let {modalType, modalProps, zIndex} = params
    return {
        type : SHOW_MODAL,
        payload : {
            modalType,
            modalProps,
            zIndex,
        }
    }
}

export const hideModal = (params) => {
    if(document){
        document.body.classList.remove('ReactModal__Body--open');
    }
    let {modalType} = params
    return {
        type : HIDE_MODAL,
        payload : {
            modalType,
        }
    }
}


window.___showModal = showModal
window.___hideModal = hideModal

/**
 * Thunk
 * */

export const qLoaderShowModal = params => dispatch => {
    let {loadingText} = params
    dispatch(showModal({
        modalType : Q_LOADER,
        modalProps : {
            loadingText,
        }
    }))
    dispatch(showLoading(LOADER_BAR_Q_LOADER_MODAL_SCOPE))
}
export const qLoaderHideModal = () => dispatch => {
    dispatch(hideModal({
        modalType : Q_LOADER,
    }))
    dispatch(hideLoading(LOADER_BAR_Q_LOADER_MODAL_SCOPE))
}


window.___qLoaderShowModal = qLoaderShowModal




// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/modules/modals.js